import React from "react";
import PropTypes from "prop-types";
import { MrbPage, MrbPageHeader, MrbPageContentHeader } from "mrb/components/layout";
import { MrbTable } from "mrb/components/table";
import { MrbQuerySearchInput } from "mrb/components/input";
import { MrbButton } from "mrb/components/button";
import { TableNoDataOverlay } from "common/components";
import { defaultTemplate } from "common/hoc";

function LoadioContentProfileListTemplate({ loadioContentProfileListViewStore, t }) {
    const { queryUtility, gridStore, layoutActions } = loadioContentProfileListViewStore;
    const createAction = layoutActions && layoutActions.create;

    return (
        <MrbPage>
            <MrbPageHeader>
                <div className="c-page__header--top">
                    <div>{t("ADMINISTRATION.LOADIO_DASHBOARD.PROFILES.TITLE")}</div>
                    {createAction && (
                        <div className="c-header__actions c-header__actions--end">
                            <MrbButton
                                t={t}
                                onClick={createAction.onClick}
                                label={createAction.label}
                                className="c-btn c-btn--base c-btn--primary"
                            />
                        </div>
                    )}
                </div>
            </MrbPageHeader>

            <MrbPageContentHeader classNameOverride="u-mar--bottom--sml">
                <div className="u-display--flex u-gap--sml f--align--items--center">
                    <MrbQuerySearchInput queryUtility={queryUtility} />
                </div>
            </MrbPageContentHeader>
            <MrbTable
                t={t}
                tableStore={gridStore}
                className="ag-theme-alpine u-mar--bottom--sml"
                emptyStateRender={TableNoDataOverlay}
            />
        </MrbPage>
    );
}

LoadioContentProfileListTemplate.propTypes = {
    loadioContentProfileListViewStore: PropTypes.object.isRequired,
    t: PropTypes.func,
};

export default defaultTemplate(LoadioContentProfileListTemplate);
